var l;!function(l){l.Full="full",l.None="none",l.Partial="partial"}(l||(l={}));const a={[l.Full]:2,[l.Partial]:1,[l.None]:0};export{a as ALGOLIA_MATCH_LEVEL_PRIORITY,l as AlgoliaMatchLevelEnum};
